import React from "react";
export default function PernyataanPrivasi() {
    return (
        <div className="breadcrumb-wrapper-promo-detail">
            <div className="general-container privacy-notice">
                <h1>Pernyataan Privasi (<i>Privacy Notice</i>)</h1>
                <p>
                    PT Adiwisista Finansial Teknologi (Danai.id) adalah Perusahaan Penyelenggara Layanan
                    Pendanaan Bersama Berbasis Teknologi Informasi (LPBBTI) dan memberikan jasa konsultasi
                    bisnis kepada pengguna Penyelenggara. Dalam hal ini, Pinjaman langsung diberikan oleh
                    Pemberi Dana kepada Pengguna, namun difasilitasi oleh Perusahaan sebagai Penyelenggara.
                </p>

                <h4>Pengumpulan Data</h4>
                <p>Pengumpulan dan perolehan data pengguna dilakukan melalui cara sebagai berikut:</p>
                <ol>
                    <li>
                        Proses pendaftaran melalui aplikasi Danai.
                        <br/>
                        Jenis data yang dikumpulkan pada proses ini adalah

                        <ul>
                            <li style={{listStyleType: "disc"}}>Email</li>
                            <li style={{listStyleType: "disc"}}>Nomor HP</li>
                            <li style={{listStyleType: "disc"}}>Data KTP</li>
                            <li style={{listStyleType: "disc"}}>Data Pekerjaan</li>
                            <li style={{listStyleType: "disc"}}>Data Kontak dan Domisili.</li>
                        </ul>
                    </li>
                    <li>
                        Proses pendaftaran melalui website.
                        <br/>
                        Jenis data yang dikumpulkan pada proses ini adalah:

                        <ul>
                            <li style={{listStyleType: "disc"}}>Email</li>
                            <li style={{listStyleType: "disc"}}>Nomor HP</li>
                            <li style={{listStyleType: "disc"}}>Data KTP</li>
                            <li style={{listStyleType: "disc"}}>Data Pekerjaan</li>
                            <li style={{listStyleType: "disc"}}>Data Kontak dan Domisili.</li>
                        </ul>
                    </li>
                    <li>
                        Ketika pengguna menghubungi customer care jenis data yang dikumpulkan pada proses
                        ini adalah:

                        <ul>
                            <li style={{listStyleType: "disc"}}>Nama</li>
                            <li style={{listStyleType: "disc"}}>Email</li>
                            <li style={{listStyleType: "disc"}}>Nomor HP</li>
                        </ul>
                    </li>
                </ol>

                <h4>Penggunaan Data</h4>
                <p>
                    Dalam melakukan pengelolaan data pribadi, Penyelenggara selalu meminta persetujuan dari
                    Pemilik Data sesuai dengan peraturan yang berlaku. Pihak penyelenggara setuju bahwa akan
                    memproses dan menggunakan semua data tertentu yang diterima dari Pemilik Data semata-mata
                    untuk tujuan perjanjian ini
                </p>
                <ul style={{listStyle: "auto"}}>
                    <li>
                        Untuk menilai dan memproses permohonan untuk Layanan dan Produk, termasuk
                        menangani masalah atau pertanyaan apa pun yang muncul selama pengajuan;
                    </li>
                    <li>
                        Mengelola dan memelihara rekening/fasilitas di PT Adiwisista Finansial Teknologi
                    </li>
                    <li>
                        Untuk mengidentifikasi kejahatan atau penipuan, melakukan investigasi, mencegah,
                        menuntut dan mematuhi sanksi, termasuk Kenali pelanggan Anda (<i>Know Your Client</i>)
                        dan mengenali para <i>Political Exposed Person</i>;
                    </li>
                    <li>
                        Untuk menanggapi persyaratan proses hukum perdata atau pidana, pemerintah
                        dan/atau badan pengatur mana pun, dan/ atau untuk tujuan kepatuhan terhadap peraturan dan/atau
                        sebagaimana diwajibkan oleh undang-undang atau peraturan;
                    </li>
                    <li>
                        Penagihan hutang, penegakan kewajiban kepada PT Adiwisista Finansial Teknologi,
                        dan/atau pemulihan uang yang sudah jatuh tempo sesuai dengan layanan dan produk;
                    </li>
                    <li>
                        Untuk audit, kepatuhan dan manajemen risiko
                    </li>
                    <li>
                        Untuk tujuan lain apa pun yang diwajibkan atau diizinkan oleh hukum, peraturan,
                        perintah dan/atau pedoman apa pun
                    </li>
                    <li>
                        Lembaga keuangan lain yang memberikan atau bermaksud memberikan fasilitas kredit
                        kepada pengguna;
                    </li>
                    <li>
                        Auditor, pengacara, penilai, konsultan dan/atau agen lain sehubungan dengan persiapan
                        kontrak/ perjanjian/laporan/saran/pendapat apa pun sehubungan dengan Layanan &amp; Produk;
                    </li>
                    <li>
                        Lembaga referensi kredit, lembaga pemeringkat, perusahaan asuransi atau pialang
                        asuransi.
                    </li>
                    <li>
                        Fintech Data Center (FDC), Pusat Data Fintech Lending (Pusdafil), Sistem Layanan
                        Informasi Keuangan (SLIK).
                    </li>
                </ul>

                <h4>Penyimpanan Data</h4>
                <p>
                    Keamanan dan privasi data adalah hal serius bagi kami, dan kami selalu memikirkan
                    metode untuk mengurangi dan mengelola risiko yang terkait dengan perlindungan dan
                    keamanan data. Jika memungkinkan, kami melakukan enkripsi dan penyamaran informasi
                    untuk menjaga privasi pengguna dan mengurangi masalah keamanan.
                </p>
                <p>
                    Sesuai POJK 10, Penyelenggara wajib menyimpan Data Pribadi dalam Sistem Elektronik
                    paling singkat 5 (lima) tahun sejak berakhirnya hubungan usaha.
                </p>

                <h4>Hak Subject Data</h4>
                <p>Sesuai diatur pada Undang-Undang No. 27 tahun 2022 tentang Perlindungan Data Pribadi:</p>
                <ul className="list-disc">
                    <li>
                        mendapatkan informasi tentang kejelasan identitas, dasar kepentingan hukum, tujuan
                        permintaan dan penggunaan data pribadi, dan akuntabilitas pihak yang meminta data pribadi
                    </li>
                    <li>
                        melengkapi, memperbarui, dan/atau memperbaiki kesalahan dan/atau ketidakakuratan data pribadi
                    </li>
                    <li>
                        mendapatkan akses dan memperoleh salinan data pribadi yang kami miliki
                    </li>
                    <li>
                        meminta kami untuk mengakhiri pemrosesan, menghapus, dan/atau memusnahkan data pribadi, dengan
                        beberapa pengecualian tertentu
                    </li>
                    <li>
                        menarik kembali persetujuan pemrosesan data pribadi yang telah diberikan
                    </li>
                </ul>

                <h4>Kegagalan Perlindungan Data</h4>
                <p>
                    Seluruh pihak yang melakukan pemrosesan ditugaskan untuk selalu memantau pelanggaran adanya
                    pelanggaran atau insiden keamanan. Apabila terdapat pelanggaran maka dalam
                    waktu paling lambat 3 (tiga) hari kalender dengan melakukan pemberitahuan tertulis kepada
                    subyek Data Pribadi dan menteri yang menyelenggarakan urusan pemerintahaan di bidang
                    komunikasi dan informatika. Pemberitahuan tertulis yang dimaksud mengenai:
                </p>
                <ul className="list-disc">
                    <li>Data Pribadi yang terungkap;</li>
                    <li>Kapan dan bagaimana Data Pribadi terungkap; dan</li>
                    <li>Upaya penanganan dan pemulihan atas terungkapnya Data Pribadi oleh Pengendali Data Pribadi.</li>
                </ul>

                <p>Kami memperbarui Pemberitahuan Privasi ini dari waktu ke waktu dan kami sarankan Anda untuk
                    memeriksanya secara berkala.</p>
                <p>Pernyataan diperbarui pada tanggal 10 Oktober 2024.</p>
                <p>Untuk pertanyaan sehubungan dengan privasi dapat menghubungi email berikut:</p>
                <p>Email Data Protection Officer: <b>dpo@danai.id</b></p>

            </div>
        </div>
    )
}